import { Link } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';
import { Heading, Text } from '@/components/system';
import { cn } from '@/lib/utils';
import { HELP_TONE_STYLES } from './help-tone-styles';
import type { HelpTopic } from '../types';

type HelpTopicCardProps = {
    topic: HelpTopic;
    articleCount: number;
};

export function HelpTopicCard({ topic, articleCount }: HelpTopicCardProps) {
    const Icon = topic.icon;
    const tone = HELP_TONE_STYLES[topic.tone];

    return (
        <Link
            to={`/help/${topic.id}`}
            className="group flex h-full min-h-36 items-start gap-4 rounded-xl border border-border/80 bg-background p-4 transition-[background-color,border-color] duration-150 ease-out hover:border-border-strong hover:bg-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
            <div
                className={cn(
                    'flex size-10 shrink-0 items-center justify-center rounded-xl border',
                    tone.icon,
                )}
            >
                <Icon className="size-5" />
            </div>

            <div className="min-w-0 flex-1 space-y-2">
                <Heading as="h3" variant="card">
                    {topic.title}
                </Heading>
                <Text variant="description">{topic.description}</Text>

                <span className="block text-xs font-medium tabular-nums text-muted-foreground">
                    {articleCount} guia{articleCount === 1 ? '' : 's'}
                </span>
            </div>

            <ArrowRight className="mt-1 size-4 shrink-0 text-muted-foreground transition-[color,transform] duration-150 ease-out group-hover:translate-x-0.5 group-hover:text-foreground" />
        </Link>
    );
}
